module.exports = __webpack_public_path__ + "img/snap_06.0777bab3.png";